import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";
import { toast } from "react-toastify";

// 🔐 SSO LOGIN
export const ssoLogin = createAsyncThunk(
  "auth/ssoLogin",

  async (idToken, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/auth/sso", {
        token: idToken,
      });

      console.log("SSO FULL RESPONSE:", response);

      // TOKEN FROM HEADER
      const authHeader = response.headers["authorization"];

      let token = null;

      if (authHeader?.startsWith("Bearer ")) {
        token = authHeader.split(" ")[1];
      }

      if (!token) {
        throw new Error("Token not found in response");
      }

      // STORE TOKEN
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("user", JSON.stringify(response.data.data));

      toast.success("Login successful");

      return {
        token,
        user: response.data.data,
      };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "SSO Login failed";

      toast.error(message);

      return rejectWithValue(message);
    }
  },
);

// 🔓 LOGOUT
export const logoutUser = createAsyncThunk(
  "auth/logoutUser",

  async (_, { rejectWithValue }) => {
    try {
      await axiosInstance.post("/auth/logout");

      sessionStorage.removeItem("token");

      toast.success("Logged out successfully 👋");

      return true;
    } catch (error) {
      const message = error.response?.data?.message || "Logout failed";

      toast.error(message);

      return rejectWithValue(message);
    }
  },
);

const authSlice = createSlice({
  name: "auth",

  initialState: {
    user: JSON.parse(sessionStorage.getItem("user")) || null,
    token: sessionStorage.getItem("token") || null,
    isAuthenticated: !!sessionStorage.getItem("token"),
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // LOGIN
      .addCase(ssoLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(ssoLogin.fulfilled, (state, action) => {
        state.loading = false;

        state.token = action.payload.token;
        state.user = action.payload.user;
        state.isAuthenticated = true;
      })

      .addCase(ssoLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // LOGOUT
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
      })

      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;

        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
      })

      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default authSlice.reducer;
